export default __webpack_public_path__ + "static/media/hero-level-3-chars-desk.315054f4.webp";